import services from '../assets/js/services'
export default {
    state: {
        casesExcellentDetails: {},  // 优秀案例详情
    },
    getters: {
    },
    actions: {
        // 获取案例台账列表
        getCasesLedgerList (context, payload) {
            return services.getSchoolTrainCases(payload).then(res => {
                return res;
            })
        },

        // 获取优秀案例列表
        getCasesExcellentList (context, payload) {
            return services.getSchoolExcellentCases(payload).then(res => {
                return res;
            })
        },
        // 优秀案例详情
        getCasesExcellentDetails (context, payload) {
            return services.getSchoolCasesDetails(payload).then(res => {
                return res;
            })
        },
        // 优秀案例 - 导出附件
        getCasesExcellentExport (context, payload) {
            return services.getSchoolCasesExport(payload).then(res => {
                return res;
            })
        },
        // 优秀案例 - 下载附件
        getCasesExcellentDownload (context, payload) {
            return services.getCasesExcellentDownload(payload).then(res => {
                return res;
            })
        },
    },
    mutations: {
        // 设置优秀案例详情
        setCasesExcellentDetails (state, payload) {
            state.casesExcellentDetails = payload.data;
        },
    }
}